export const SPORT_TYPE_FOOTBALL = 'football';
